import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    first_name: '',
    last_name: '',
    email: '',
    mobileno: '',
    password: '',
    id:'',
    selected_hub: null,
    userCart: [],
    cart_id:''
};


const userReducer = createSlice({
    name: "userReducer",
    initialState: initialState,
    reducers: {
        updateFirst_name: (state, {  payload }) => {
            state.first_name = payload
        },
        updateLast_name: (state, {  payload }) => {
            state.last_name = payload
        },
        updateEmail: (state, {  payload }) => {
            state.email = payload
        },
        updateMobileno: (state, {  payload }) => {
            state.mobileno = payload
        },
        updateId: (state, {  payload }) => {
            state.id = payload
        },
        updateSelectedHub: (state, {  payload }) => {
            state.selected_hub = payload
        },
        updateUserCart:(state, {  payload }) => {
            state.userCart = payload
        },
        updateCartId: (state, { payload }) => {
            state.cart_id = payload
        },
    }
    })

export const { updateFirst_name, updateLast_name, updateEmail, updateMobileno, updateId, updateSelectedHub, updateUserCart, updateCartId } = userReducer.actions
    
    export default userReducer.reducer;